import { defineField } from "sanity";
export default defineField({
  title: "Button Type",
  type: "string",
  name: "buttonType",
  description: "leave empty for default",
  options: {
    list: [
      { title: "Primary", value: "new_primary" },
      { title: "Accent", value: "new_accent" },
      { title: "Secondary", value: "new_secondary" },
      { title: "Text", value: "new_text" },
      { title: "Link", value: "new_link" },

      { title: "Primary inverted", value: "new_primary_inverted" },
      { title: "Accent inverted", value: "new_accent_inverted" },
      { title: "Secondary inverted", value: "new_secondary_inverted" },
      { title: "Text inverted", value: "new_text_inverted" },

      { title: "(old) Primary", value: "primary" },
      { title: "(old) Secondary", value: "secondary" },
      { title: "(old) Secondary (gray)", value: "secondary-gray" },
      { title: "(old) Tertiary", value: "tertiary" },
      { title: "(old) Link", value: "link" }
    ]
  }
});
